import { object, string } from 'yup'

import { CoachingExperience } from '../../../api'
import { i18nErrorCodes }     from '../form-utils'

const { required } = i18nErrorCodes

export default object().shape({
  sector:  string().required(required),
  company: string().required(required),
})

export const emptyCoachingExperience = {
  sector:  '',
  company: '',
}

export interface CoachingExperienceValues {
  coachingExperiences: CoachingExperience [],
}



// WEBPACK FOOTER //
// ./src/components/forms/schemas/coaching-experience.schema.ts